import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { NgkAuthInterceptor, NgkAuthService } from '@kin/ngk-auth';
import { NgKLoggerService } from '@kin/ngk-logger';
import { WA_SESSION_STORAGE, WA_WINDOW } from '@ng-web-apis/common';

import { appInitializerFactory } from 'app/app-config';
import { AppConfigService } from 'app/app-config/app-config.service';
import { routes } from 'app/app.routes';
import { LegacyQuotesApiInterceptor } from 'app/home/common/interceptors/legacy-quotes-api/legacy-quotes-api-interceptor.service';
import { FullstoryService } from 'app/shared/services/fullstory/fullstory.service';
import { GuidService } from 'app/shared/services/guid/guid.service';
import { SplitIOService } from 'app/shared/services/splitIO/splitIO.service';

export const appConfig: ApplicationConfig = {
  providers: [
    AppConfigService,
    GuidService,
    NgKLoggerService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: LegacyQuotesApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NgkAuthInterceptor, multi: true },
    provideAppInitializer(() => {
      const initializerFn = appInitializerFactory(
        inject(AppConfigService),
        inject(WA_WINDOW),
        inject(NgKLoggerService),
        inject(FullstoryService),
        inject(GuidService),
        inject(SplitIOService),
        inject(WA_SESSION_STORAGE),
        inject(NgkAuthService),
      );
      return initializerFn();
    }),
    provideAnimationsAsync(),
  ],
};
